import { useState, useEffect } from 'react';
import { getComponentFrameworkDisplayData } from '@pm2/iframe-component';
import { useUserIdentityState } from '@provider/user-identity';
import { ExternalLinkIcon } from '@ui/kit/icons';
import { UniversalContextMenuButton } from '@utils/component-framework';
import { jsx } from 'react/jsx-runtime';

function NewWindowButton(props) {
  if (props.node.nodeType === "iframe-component" || props.node.nodeType === "iframe-component.component-framework") {
    return /*#__PURE__*/jsx(IframeInNewWindowButton, {
      node: props.node
    });
  }
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    as: "a",
    label: "\xC5bn i nyt vindue",
    icon: /*#__PURE__*/jsx(ExternalLinkIcon, {}),
    href: `/learningObject/${props.learningObjectId}`,
    target: "_blank",
    onClick: props.onClick
  });
}
function IframeInNewWindowButton(props) {
  const user = useUserIdentityState(state => state.user);
  const [src, setSrc] = useState(undefined);
  useEffect(() => {
    if ("displayData" in props.node) {
      setSrc(props.node.displayData.src);
      return;
    }
    let isActive = true;
    getComponentFrameworkDisplayData(props.node, user).then(displayData => {
      if (!isActive) {
        return;
      }
      setSrc(displayData.src);
    });
    return () => {
      isActive = false;
    };
  }, [props.node, user]);
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    as: "a",
    label: "\xC5bn i nyt vindue",
    icon: /*#__PURE__*/jsx(ExternalLinkIcon, {}),
    href: src,
    target: "_blank",
    onClick: props.onClick
  });
}

export { NewWindowButton };
//# sourceMappingURL=new-window-button.js.map
